(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('storeCart', StoreCart)

    /** @ngInject */
    function StoreCart($timeout, $state, $filter, HelperService, sweetAlert, ProductService, PATHS) {
        function StoreCartController() {
            const vm = this;

            vm.cartTotal = () => {
                return ProductService.getProductsTotal(vm.products);
            }

            vm.getProductStock = product => {
                let stock = false;

                if (ProductService.isNetSuiteProduct(product))
                    stock = product.StockAvailable;

                return stock;
            }

            vm.updateProduct = product => {
                $timeout(() => {
                    ProductService.updateProductAmount(product.UnitId, product.ProviderId, product.Id, product.Amount);
                });
            }

            vm.deleteProduct = product => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Essa ação é irreversível!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    const isConfirmed = response === true || (response && (response.value || response.isConfirmed));

                    if (isConfirmed && product) {
                        HelperService.startLoading('.cart-holder');

                        ProductService.removeProduct(product.UnitId, product.ProviderId, product);

                        HelperService.stopLoading('.cart-holder');
                    }
                })
            }

            vm.clearCart = () => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Todos os itens da cesta serão removidos.',
                    type: 'warning',
                    confirmButtonText: 'Sim, remover todos',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    const isConfirmed = response === true || (response && (response.value || response.isConfirmed));

                    if (isConfirmed) {
                        HelperService.startLoading('.cart-holder');

                        ProductService.clearProducts();

                        HelperService.stopLoading('.cart-holder');
                    }
                })
            }

            vm.checkoutOrder = () => {
                const productsList = angular.copy(vm.products);

                let providerList = productsList.reduce((acc, cur) => {
                    cur.Provider.Products = productsList.filter(x => x.ProviderId == cur.Provider.Id);

                    acc.push(cur.Provider);

                    return acc;
                }, []).filter((elem, pos, arr) => arr.map(mapObj => mapObj.Id).indexOf(elem.Id) === pos);

                for (let i = 0; i < providerList.length; i++) {
                    const provider = providerList[i];

                    let providerValue = provider.Products.reduce((acc, cur) => {
                        return acc + (cur.Value * cur.Amount);
                    }, 0);

                    if (providerValue < provider.MinimumValue) {
                        let minimumValue = $filter('currency')(provider.MinimumValue, 'R$', 2);

                        sweetAlert.swal({
                            title: 'Pedido inválido!',
                            text: `O pedido mínimo do fornecedor ${provider.Title} é de ${minimumValue}`,
                            type: 'error',
                            confirmButtonText: 'Voltar às compras',
                            showCancelButton: true,
                            cancelButtonText: 'Fechar',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });

                        return;
                    }
                }

                $state.go('app.cart');
            }

            init();

            function init() {
                $timeout(() => {
                    $.fn.scrollbar && $('.cart-body').scrollbar({
                        ignoreOverlay: false
                    });
                }, 250);
            }
        }

        return {
            bindToController: true,
            controller: StoreCartController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/store-cart/store-cart.html`,
            scope: {
                products: '='
            }
        }
    }
}());
